export enum TimeslotVariantEnum {
  Primary = 'primary',
  RightColCentered = 'right-centered',
}
